import { defineStore } from 'pinia'
import axios from 'axios'
import socket from '../socket';
export const useCounterStore = defineStore('counter', {
  state: () => ({
    // baseURL: 'http://127.0.0.1:3000',
    baseURL: 'https://api.iotgh-bisipujon.online',
    dataUser: {},
    dataAllUser: [],
    dataDetailPlant: {},
    dataRealtime: {},
    dataRealtimeSuhu: {},
    dataGroups: [],
    dataGroupDetail: {},
    dataAllPlants: [],
    dataUser: {},
    dataMemberException: [],
    dataMemberExcepClass: [],
    dataSensor: [],
    dataAnySensor: [],
    isAuthenticated: localStorage.access_token ? true : false,
    seriesArea: [
      {
        name: "Humidity",
        data: [0]
      },
    ],
  }),
  actions: {
    async getAnySensor() {
      try {
        const { data } = await axios({
          url: this.baseURL + `/anySensor`,
          method: 'get',
          headers: { access_token: localStorage.getItem('access_token') }
        })
        this.dataAnySensor = data
      } catch (error) {
        console.log(error)
      }
    },
    async downloadExcel(start, end, dataid, inc) {
      try {
        if (inc !== 3) {
          if (!start || !dataid) {
            console.log("Start date and data ID are required.");
            return;
          }
        }
        const body = {
          start: start,
          end: end || null,
          dataid: dataid,
          inc: inc
        };

        const response = await axios({
          url: `${this.baseURL}/excelDownload`,
          method: 'post',
          headers: {
            access_token: localStorage.getItem('access_token'),
            'Content-Type': 'application/json'
          },
          data: body,
          responseType: 'blob'
        });
        const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = 'data.xlsx';
        link.click();
        URL.revokeObjectURL(link.href);
      } catch (error) {
        console.error('Error downloading the file:', error);
      }
    },
    async changeMail(email) {
      try {
        const { data } = await axios({
          url: this.baseURL + `/changeEmail`,
          method: 'patch',
          headers: { access_token: localStorage.getItem('access_token') },
          data: { email }
        })
        return true
      } catch (error) {
        return error.response.data.message
      }
    },
    async editUser(dataUser) {
      try {
        const { data } = await axios({
          url: this.baseURL + `/user`,
          method: 'put',
          headers: { access_token: localStorage.getItem('access_token') },
          data: dataUser
        })
        return true
      } catch (error) {
        return error.response.data.message
      }
    },
    async verifyCode(verifyCode) {
      try {
        const { data } = await axios({
          url: this.baseURL + `/verifyCode`,
          method: 'post',
          headers: { access_token: localStorage.getItem('access_token') },
          data: { verifyCode }
        })
        await this.getDataUser()
        return true
      } catch (error) {
        return error.response.data.message
      }
    },
    async sendCode() {
      try {
        const { data } = await axios({
          url: this.baseURL + `/sendCode`,
          method: 'get',
          headers: { access_token: localStorage.getItem('access_token') }
        })
        return true
      } catch (error) {
        return error.response.data.message
      }
    },
    async changePassword(newPassword, token) {
      try {
        if (!token) {
          token = localStorage.getItem('access_token')
        }
        const { data } = await axios({
          url: this.baseURL + `/changePass`,
          method: 'patch',
          headers: { access_token: token },
          data: { newPassword }
        });
        return true
      } catch (error) {
        return error.response.data.message
        console.log(error);
      }
    },
    async checkToken(token) {
      try {
        const { data } = await axios({
          url: this.baseURL + '/checkToken?token=' + token,
          method: 'get',
        })
        return true
      } catch (error) {
        return error.response.data.message
      }
    },
    async forgotPassword(email) {
      try {
        const { data } = await axios({
          url: this.baseURL + '/forgotPassword',
          method: 'post',
          data: { email }
        })
        return true
      } catch (error) {
        return error.response.data.message
      }
    },
    async getDataAllUser() {
      try {
        const { data } = await axios({
          url: this.baseURL + `/allUser`,
          method: 'get',
          headers: { access_token: localStorage.getItem('access_token') }
        });
        this.dataAllUser = data;
      } catch (error) {
        console.log(error);
      }
    },
    async getDataUser() {
      try {
        const { data } = await axios({
          url: this.baseURL + `/user`,
          method: 'get',
          headers: { access_token: localStorage.getItem('access_token') }
        });
        this.dataUser = data;
      } catch (error) {
        console.log(error);
      }
    },
    async getDataSensor(search) {
      try {
        const { data } = await axios({
          url: this.baseURL + `/sensor?search=${search}`,
          method: 'get',
          headers: { access_token: localStorage.getItem('access_token') }
        });
        this.dataSensor = data;
      } catch (error) {
        console.log(error);
      }
    },
    async delDataSensor() {
      this.dataSensor = []
    },
    async getMemberGroup(id, query) {
      try {
        let url = this.baseURL + '/member/' + id
        if (query && query != 0) {
          url += `?clas=${query}`
        }
        const { data } = await axios({
          url,
          method: 'get',
          headers: { access_token: localStorage.getItem('access_token') }
        })
        this.dataAllPlants = data
      } catch (error) {
        console.log(error)
      }
    },
    async delMemberGroup(GroupId, dataPlant, clas) {
      try {
        const res = await this.SweetAlertDelete()
        if (!res) {
          return
        }
        let url = this.baseURL + '/member/' + GroupId
        if (clas !== 0) {
          url += `?clas=${clas}`
        }
        const { data } = await axios({
          url,
          method: 'delete',
          headers: { access_token: localStorage.getItem('access_token') },
          data: { dataPlant }
        })
        this.sweetAlertSuccess('Plant remove from' + clas == 0 ? 'group' : 'classification')
        await this.getMemberGroup(GroupId, clas)
      } catch (error) {
        console.log(error)
      }
    },
    async editPLant(id, dataEdit) {
      try {
        const { data } = await axios({
          url: this.baseURL + '/plant/' + id,
          method: 'put',
          headers: { access_token: localStorage.getItem('access_token') },
          data: dataEdit
        })
        this.$router.push('/plant/' + id)
      } catch (error) {

      }
    },
    async getDetailPLant(id) {
      try {
        const { data } = await axios({
          url: this.baseURL + '/plant/' + id,
          method: 'get',
          headers: { access_token: localStorage.getItem('access_token') }
        })
        this.dataDetailPlant = data
      } catch (error) {

      }
    },
    async postNewPlant(newData) {
      try {
        const { data } = await axios({
          url: this.baseURL + '/plant',
          method: 'post',
          headers: { access_token: localStorage.getItem('access_token') },
          data: newData
        })
        await this.getAllPlanst()
      } catch (error) {

      }
    },
    async delPlant(id) {
      try {
        const res = await this.SweetAlertDelete()
        if (!res) {
          return
        }
        const { data } = await axios({
          url: this.baseURL + '/plant',
          method: 'delete',
          headers: { access_token: localStorage.getItem('access_token') },
          data: { id }
        })
        this.sweetAlertSuccess("Plans delete")
        return true
      } catch (error) {

      }
    },
    async getAllPlanst() {
      try {
        const { data } = await axios({
          url: this.baseURL + '/plants',
          method: 'get',
          headers: { access_token: localStorage.getItem('access_token') }
        })
        this.dataAllPlants = data
      } catch (error) {

      }
    },
    async getRealtimeSensor() {
      try {
        socket.on('message', (data) => {
          this.dataRealtime = data
        });
      } catch (error) {
        console.log(error)
      }
    },
    async getRealtimeSensorSuhu() {
      try {
        socket.on('dataSuhu', (data) => {
          this.dataRealtimeSuhu = data
        });
      } catch (error) {
        console.log(error)
      }
    },
    async createGroup(dataFrom) {
      try {
        const { data } = await axios({
          url: this.baseURL + '/group',
          method: 'post',
          headers: { access_token: localStorage.getItem('access_token') },
          data: { name: dataFrom }
        })
        await this.getDataGroup()
        console.log('ok')
      } catch (error) {
        return "bosok"
        console.log(error)
      }
    },
    async getDataGroup() {
      try {
        const { data } = await axios({
          url: this.baseURL + '/group',
          method: 'get',
          headers: { access_token: localStorage.getItem('access_token') },
        })
        this.dataGroups = data
      } catch (error) {
        return "bosok"
        console.log(error)
      }
    },
    async getDetailGroup(id) {
      try {
        const { data } = await axios({
          url: this.baseURL + '/group/' + id,
          method: 'get',
          headers: { access_token: localStorage.getItem('access_token') }
        })
        this.dataGroupDetail = data
      } catch (error) {
        console.log(error)
      }
    },
    async editGroup(id, name) {
      try {
        const { data } = await axios({
          url: this.baseURL + '/group/' + id,
          method: 'patch',
          headers: { access_token: localStorage.getItem('access_token') },
          data: { name }
        })
        this.sweetAlertSuccess('Change name to ' + name)
        return data
      } catch (error) {
        console.log(error)
      }
    },
    async delGroup(id) {
      try {
        const { data } = await axios({
          url: this.baseURL + '/group/' + id,
          method: 'delete',
          headers: { access_token: localStorage.getItem('access_token') }
        })
        Swal.fire({
          title: "Deleted!",
          text: "Group has been deleted.",
          icon: "success",
          confirmButtonColor: "#3085d6"
        });
        this.$router.push('/group')
      } catch (error) {
      }
    },
    async postClass(id, name) {
      try {
        const { data } = await axios({
          url: this.baseURL + '/classification',
          method: 'post',
          headers: { access_token: localStorage.getItem('access_token') },
          data: {
            name,
            GroupId: id
          }
        })
        console.log(id, '-------')
        this.getDetailGroup(id)
      } catch (error) {
        console.log(error)
      }
    },
    async editClass(id, name, idGroup) {
      try {
        const { data } = await axios({
          url: this.baseURL + '/classification/' + id,
          method: 'patch',
          headers: { access_token: localStorage.getItem('access_token') },
          data: { name }
        })
        this.getDetailGroup(idGroup)
      } catch (error) {
        console.log(error)
      }
    },
    async delClass(id, id2) {
      try {
        const res = await this.SweetAlertDelete()
        if (!res) {
          return
        }
        const { data } = await axios({
          url: this.baseURL + '/classification/' + id,
          method: 'delete',
          headers: { access_token: localStorage.getItem('access_token') },
        })
        this.sweetAlertSuccess("Delete Classification")
        await this.getDetailGroup(id2)
      } catch (error) {

      }
    },
    async getDataChart(id, date, setup) {
      try {
        let url = this.baseURL + '/plant/chart/' + id
        if (setup) {
          url += ('?setup=' + setup)
        }
        if (date) {
          if (setup) {
            url += ('&date=' + date)
          } else {
            url += ('?date=' + date)
          }
        }

        const { data } = await axios({
          url,
          method: 'get',
          headers: { access_token: localStorage.getItem('access_token') }
        })
        let resultHumidity = []
        let resultTemperature = []
        let resultAvgTemp = []
        let resultAvgHumi = []
        if (setup) {
          data.temperature.forEach(el => {
            resultTemperature.push(el.data)
          });
          data.humidity.forEach(el => {
            resultHumidity.push(el.data)
          });
          data.avgTemperature.forEach(el => {
            resultAvgTemp.push(el.data)
          });
          data.avgHumidity.forEach(el => {
            resultAvgHumi.push(el.data)
          });
          this.seriesArea = [{
            name: "Humidity",
            data: resultHumidity
          },
          {
            name: "Temperature",
            data: resultTemperature
          }, {
            name: "Avg Temperature",
            data: resultAvgTemp
          }, {
            name: "Avg Humidity",
            data: resultAvgHumi
          }]
        } else {
          data.forEach(el => {
            resultHumidity.push(el.moisture)
          });
          this.seriesArea = [{
            name: "Humidity",
            data: resultHumidity
          }]
        }
        return true
      } catch (error) {
        console.log(error)
        return false
      }
    },
    async createMember(plantId, id, idClass) {
      try {
        const { data } = await axios({
          url: this.baseURL + '/member/' + id,
          method: 'post',
          headers: { access_token: localStorage.getItem('access_token') },
          data: { plantId }
        })
        if (idClass === 0) {
          idClass = null
        }
        await this.getMemberGroup(id, idClass)
      } catch (error) {
        console.log(error)
      }
    },
    async createMemberClass(dataAdd, idGroup, idClas) {
      try {
        const { data } = await axios({
          url: this.baseURL + '/classification/' + idClas,
          method: 'put',
          headers: { access_token: localStorage.getItem('access_token') },
          data: { dataAdd }
        })
        await this.getMemberGroup(idGroup, idClas)
      } catch (error) {
        console.log(error)
      }
    },
    async getDataMemeberException(id, clas, show, search) {
      try {
        let url = this.baseURL + '/member/' + id + '/except'
        if (clas != null) {
          url += '?clas=yes'
        } else {
          if (show !== undefined) {
            url += `?show=${show}`;
          }
          if (search) {
            url += (url.includes('?') ? `&search=${search}` : `?search=${search}`);
          }
        }
        const { data } = await axios({
          url,
          method: 'get',
          headers: { access_token: localStorage.getItem('access_token') }
        })
        if (!clas) {
          this.dataMemberException = data
        } else {
          this.dataMemberExcepClass = data
        }
      } catch (error) {
        console.log(error)
      }
    },
    async getDataProfile() {
      try {
        const { data } = await axios({
          url: this.baseURL + '/user',
          method: 'get',
          headers: { access_token: localStorage.getItem('access_token') }
        })
        this.dataUser = data
      } catch (error) {
        console.log(error)
      }
    },
    async login(email, password) {
      try {
        const { data } = await axios({
          url: this.baseURL + '/login',
          method: 'post',
          data: { email, password }
        })
        localStorage.setItem('access_token', data.access_token)
        console.log(data.access_token)
        this.isAuthenticated = true
        this.$router.push('/')
        this.sweetAlertSuccess('Sign in')
      } catch (error) {
        console.log(error)
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: error.response.data.message
        })
      }
    },
    async register(value) {
      try {
        const { data } = await axios({
          url: this.baseURL + '/register',
          method: 'post',
          data: value
        })
        // this.$router.push('/login')
        console.log(data)
        Swal.fire({
          title: `${data.email} done create, you can log in`,
          showClass: {
            popup: 'animate__animated animate__fadeInDown'
          },
          hideClass: {
            popup: 'animate__animated animate__fadeOutUp'
          }
        })
        this.$router.push('/login')
      } catch (error) {
        console.log(error.response)
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: error.response.data.message
        })
      }
    },
    sweetAlertSuccess(value) {
      const Toast = Swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener('mouseenter', Swal.stopTimer)
          toast.addEventListener('mouseleave', Swal.resumeTimer)
        }
      })
      Toast.fire({
        icon: 'success',
        title: value + ' in successfully'
      })
    },
    async SweetAlertDelete() {
      const res = await Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!"
      }).then((result) => {
        if (result.isConfirmed) {
          return true
        } else {
          return false
        }
      });
      return res
    },
    sweetAlertError(error) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: error.response.data.message,
      });
    }

  }
})
